import { render, staticRenderFns } from "./UpdateNotificationManagePopUp.vue?vue&type=template&id=b587f1ae&scoped=true&"
import script from "./UpdateNotificationManagePopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateNotificationManagePopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNotificationManagePopUp.vue?vue&type=style&index=0&id=b587f1ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b587f1ae",
  null
  
)

export default component.exports